import { UserProductCatalogDto } from '@api/api-service';
import { CatalogFilter } from '@app/shared/interface/webshop.interface';
export interface ProductCatalogStore {
    productCatalogs: UserProductCatalogDto[];
    filter: CatalogFilter;
    error: string | null;
}

export const initialProductCatalogStore: ProductCatalogStore = {
    productCatalogs: [],
    filter: {
        searchTerm: '',
        catalogs: [],
        productGroups: [],
        publishStatus: 'all',
        priceMin: 0,
        priceMax: 0,
        sort: 'price-asc',
    },
    error: null,
};
